import { IBaseDataParser } from "../../../../vendor_core/core/src/server/parsers/IBaseDataParser";
import BURReelsModel from "../../models/BURReelsModel";

export default class BURSessionDataParser implements IBaseDataParser<{}> {
    check(data: any): boolean {
        return data?.data?.lastSessionData;
    }

    parse(data: any): {} | {}[] {
        const lastSpinData =
            data.data.lastSessionData.betResult.playData.gameData;
        const hasFreeSpins = lastSpinData.bonusInfo.length > 0;
        const hasReplayFreeSpins = lastSpinData.replay?.bonusInfo?.length > 0;
        if (lastSpinData.lastFinalView.length > 0) {
            BURReelsModel.setLastFinalView(lastSpinData.lastFinalView);
        }

        if (hasFreeSpins) {
            BURReelsModel.setPreTriggerMetersProgress(
                lastSpinData.featureInfo.meters
            );
            BURReelsModel.setPreTriggerCombo(
                lastSpinData.featureInfo.trigger.combo
            );
        } else if (hasReplayFreeSpins) {
            BURReelsModel.setPreTriggerMetersProgress(
                lastSpinData.replay.featureInfo.meters
            );
            BURReelsModel.setPreTriggerCombo(
                lastSpinData.replay.featureInfo.trigger.combo
            );
        }
        return [];
    }
}
